import Server from '@/service/server'
import persianDate from 'persian-date/dist/persian-date.js'

export default {
  namespaced: true,
  state: {
    userReviewModalVisibility: false,
    productComments:[],
    productRate:{},
    userProductRate: {}
  },
  getters: {
    userReviewModalVisibility (state: any) {
      return state.userReviewModalVisibility
    },
    productComments(state: any)
    {
        return state.productComments
    },
    productRate(state:any)
    {
        return state.productRate
    },
    userProductRate(state:any)
    {
        return state.userProductRate
    }
  },
  actions: {
    showUserReviewModal (context: any) {
      context.commit('setshowUserReviewModal')
    },
    hideUserReviewModal (context: any, payload: any) {
      context.commit('sethideUserReviewModal')
    },
    loadProductComments(context: any, id: number)
    {
        const promise = Server.getComments({ productId:id, state:'Accept', pageIndex:0, pageSize:100})
        promise.then((response: any) => {
          let result = response.body.result
          context.commit('productCommentsLoaded', result)
        })
        return promise
    },
    addComment(context: any, payload: any){
        let params = {
          productid: payload.productId,
          text: payload.commentText,
          replytoid: payload.replayToId
        }
        const promise = Server.addComment(params).then((response:any)=>{
            var result = response.body.result
            if(response.body.success === true)
            {
              return response
            }
        },
        (error: any) =>{

        }
        )
        return promise
    },
    getProductRate(context: any, id: number)
    {
      const promise = Server.getProductRate({productId: id})
      promise.then((response:any)=>{
        let result = response.body.result
        context.commit('productRateLoaded', result)
      },
      (error: any) =>{

      }
      )
      return promise
    },
    getUserProductRate(context: any, id: number)
    {
        const promise = Server.getUserProductRate({productId: id})
        promise.then((response:any)=>{
          let result = response.body.result
          context.commit('userProductRateLoaded', result)
        },
        (error: any)=>{

        }
        )
        return promise
    },
    rateProduct(context: any, payload: any)
    {
      let params = {
        productId: payload.productId,
        count: payload.rate
      }
      const promise = Server.rateProduct(params).then((response:any)=>{
        var result = response.body.result
        if(response.body.success === true)
        {
          return response
        }
      },
      (error: any)=>{

      }
      )
      return promise
    }
  },

  mutations: {
    setshowUserReviewModal (state: any) {
      state.userReviewModalVisibility = true
    },
    sethideUserReviewModal (state: any) {
      state.userReviewModalVisibility = false
    },
    productCommentsLoaded(state:any, productComments: Array<any>)
    {
      let comments = new Array()
      productComments.forEach((comment)=>{
        let productComment = {
          nickname:comment.nickName === undefined? '': comment.nickName,
          rate:comment.rate === undefined? 0 : comment.rate,
          description:comment.text === undefined ? '':comment.text,
          firstName:comment.firstName === undefined ? '':comment.firstName,
          lastName:comment.lastName === undefined ? '': comment.lastName,
          date: new persianDate(new Date(comment.createAt)).format('L'),
        }
        comments.push(productComment)
      })
      state.productComments = comments
    },
    productRateLoaded(state: any, payload: any)
    {
      state.productRate = payload
    },
    userProductRateLoaded(state: any, payload: any)
    {
      state.userProductRate = payload
    }
  }
}
